module.exports = __webpack_public_path__ + "img/18-01_Being Experimental.4a861fca.svg";